module.exports = __webpack_public_path__ + "img/voice-recorder.0fef5b69.svg";